import React from 'react';
import Card from '../../../core/layout/Card';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import RankingListFilterContainer from './RankingListFilterContainer';
import Separator from '../../../core/layout/Separator';
import Tabs from '../../../core/layout/Tabs';
import RankingListPanelContainer from './RankingListPanelContainer';
import MonthRankingFilterContainer from './MonthRankingFilterContainer';
import ColumnSeparator from '../../../core/layout/ColumnSeparator';
import moment from 'moment';

const RankingListScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Students Ranking',
        },
      ]}
    />
    <Card key="card">
      <RankingListFilterContainer />
    </Card>
    <Separator key="separator" />
    <Tabs
      tabs={[
        {
          title: (
            <div
              style={{
                display: 'flex',
                height: 40,
              }}
            >
              <span style={{ marginTop: 10 }}>Top of</span>
              <ColumnSeparator size="xs" />
              <MonthRankingFilterContainer />
            </div>
          ),
          key: 'monthly',
          content: <RankingListPanelContainer type="month" />,
        },
        {
          title: 'Top of Current Semester',
          key: 'semester',
          content: <RankingListPanelContainer type="semester" />,
        },
        {
          title: `Top of Year (${moment().year()})`,
          key: 'year',
          content: <RankingListPanelContainer type="year" />,
        },
        {
          key: 'all',
          title: 'Top of All time',
          content: <RankingListPanelContainer type="all" />,
        },
      ]}
    />
  </div>
);

export default RankingListScene;
